import styled from 'styled-components';

export const TableReportsSubscriberFooterStyled = styled.div`
    display: grid;
    width: 100%;
    justify-content: end;
    margin: 16px 0;
`;
